import React from "react";
import { createRoot } from "react-dom/client";
// Importar configuración de jQuery antes que todo lo demás
import "./jquery-config";
import "./index.css";
import App from "./App";
import { MsalProvider } from "@azure/msal-react";
import { PublicClientApplication } from "@azure/msal-browser";
import { Provider as ReduxProvider } from "react-redux";
import { msalConfig } from "./authConfig";
import { store, persistor } from "../src/SharedModule/redux/store";
import { PersistGate } from "redux-persist/integration/react";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router";
import { DEVELOPMENT } from "./SharedModule/utils/constants";
import ScrollToTop from "./SharedModule/components/ScrollToTop";

/**
 * Initialize a PublicClientApplication instance which is provided to the MsalProvider component
 * We recommend initializing this outside of your root component to ensure it is not re-initialized on re-renders
 */
const msalInstance = new PublicClientApplication(msalConfig);

const APP_VERSION = process.env.REACT_APP_CURRENT_GIT_SHA;

if (localStorage.APP_VERSION !== APP_VERSION) {
  localStorage.clear();
  localStorage.setItem("APP_VERSION", APP_VERSION as string);
}

const container = document.getElementById("root");
const root = createRoot(container!);

root.render(
  <React.StrictMode>
    <MsalProvider instance={msalInstance}>
      <ReduxProvider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <BrowserRouter>
              <ScrollToTop />
              <App />
            </BrowserRouter>
        </PersistGate>
      </ReduxProvider>
    </MsalProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
